"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const stimulus_1 = require("@hotwired/stimulus");
class default_1 extends stimulus_1.Controller {
    get el() {
        return this.element;
    }
    connect() {
        const locationInput = this.el.querySelector("[name=locationId]");
        locationInput === null || locationInput === void 0 ? void 0 : locationInput.addEventListener("change", (event) => {
            const target = event.target;
            this.el.submit();
        });
    }
    showFilterDialog() {
        this._log("showFilterDialog:start");
        this.filterDialogController = this.application.getControllerForElementAndIdentifier(this.filterDialogTarget, "dialog");
        this.filterDialogPromise = this.filterDialogController.show();
        this._log("showFilterDialog:start");
    }
    hideFilterDialog(event) {
        var _a;
        this._log("showFilterDialog:start");
        this.filterDialogPromise = undefined;
        (_a = this.filterDialogController) === null || _a === void 0 ? void 0 : _a.close();
        this._log("showFilterDialog:end");
    }
    clearFilters(event) {
        const estimatedGuestsInput = this.element.querySelector("[name='estimatedGuests']");
        if (estimatedGuestsInput) {
            estimatedGuestsInput.value = "";
        }
        const departingDateInput = this.element.querySelector("[name='departingDate']");
        if (departingDateInput) {
            departingDateInput.value = "";
        }
        const durationInputs = this.element.querySelectorAll("[name='duration']");
        durationInputs.forEach((el) => (el.checked = false));
        const sortInputs = this.element.querySelectorAll("[name='sort']");
        sortInputs.forEach((el) => (el.checked = false));
    }
    render() { }
    _log(text) {
        console.log(this.identifier + ":" + text);
    }
}
exports.default = default_1;
default_1.targets = ["locationDialog", "filterDialog"];
